import { GAME_STATUSES, ORIENTATIONS } from './constants';
import Model from './model';
import View from './view';

// keycode - branchIndex
const KEYCODES_BRANCHINDEX = {
    KeyA: 0,
    KeyK: 1,
    KeyZ: 2,
    KeyM: 3
};

export class Controller {
    #isPaused = false;

    get score() {
        return this.model.score;
    }

    constructor() {
        this.model = new Model();
        this.view = new View(this.model);
        this.initEvents();
    }

    initEvents() {
        this.initOrientationEvent();
        this.initCharacterEvents();
    }

    update() {
        this.model.update();
        this.view.update();

        // ! work
        if (this.model.gameStatus === GAME_STATUSES.PLAY || this.model.gameStatus === GAME_STATUSES.BEFORE_PLAY) {
            requestAnimationFrame(() => this.update());
        }
    }

    // метод, для того, чтобы начать игровой процесс (начинается с запуска таймера)
    startGame() {
        this.model.startGame();
        this.update();
        this.checkOrientation();
    }

    restartGame() {
        this.model.restartGame();
        this.view.restartGame();
        this.update();
        this.checkOrientation();
    }

    checkToContinueGame() {
        if (!this.#isPaused) {
            this.continueGame();
        }
    }

    continueGame() {
        this.#isPaused = false;
        this.model.continueGame();
        this.update();
    }

    pause() {
        this.model.pause();
        this.#isPaused = true;
    }

    pressedControlKey(keyCode) {
        if (keyCode in KEYCODES_BRANCHINDEX) {
            this.model.changeCharacterPosition(KEYCODES_BRANCHINDEX[keyCode]);
            this.view.drawCharacterPosition();
        }
    }

    initControllButtons() {
        this.view.initControlButtons();

        const controlButtons = document.querySelectorAll('.control-button');

        Array.from(controlButtons).forEach((button) => {
            button.addEventListener('click', () => {
                this.model.changeCharacterPosition(button.getAttribute('branch-index'));
                this.view.drawCharacterPosition();
            });
        });
    }

    // подписка на прослушивание событий для передвижения персонажа
    initCharacterEvents() {
        const isTouchCapable = 'ontouchstart' in window
        || (window.DocumentTouch && document instanceof window.DocumentTouch)
        || navigator.maxTouchPoints > 0
        || window.navigator.msMaxTouchPoints > 0;

        if (isTouchCapable) {
            this.initControllButtons();
        }
    }

    initOrientationEvent() {
        window.addEventListener('orientationchange', () => {
            this.checkOrientation();
        });

        window.addEventListener('resize', () => {
            this.checkOrientation();
        });
    }

    checkOrientation() {
        // eslint-disable-next-line
        switch (this.model.gameStatus) {
            case GAME_STATUSES.PLAY:
            case GAME_STATUSES.BEFORE_PLAY:
            case GAME_STATUSES.PAUSE:
                if ((window.innerWidth < 425 && window.screen.orientation && window.screen.orientation.type !== ORIENTATIONS.LANDSCAPE)
                    || (window.innerWidth < 425 && window.innerHeight > window.innerWidth)
                ) {
                    this.model.changeOrientation(ORIENTATIONS.PORTRAIT);
                } else {
                    this.model.changeOrientation(ORIENTATIONS.LANDSCAPE);
                    this.checkToContinueGame();
                }

                break;
        }
    }

    windowResize() {
        this.view.setSizes();
    }
}
